/* Variant: an always-visible language switch, labelled in the language you
   would be switching TO.

   The theme ships a switcher twice and both miss their audience. The top-bar
   copy lives in .topbar__left, which is "hidden lg:flex", so on a phone it does
   not render at all. The drawer copy is real but sits at y=766 in an 812px
   viewport, below eleven category rows, and is labelled "Language / English" —
   the language you are already reading. Someone who wants Arabic is shown the
   English word "English" and nothing in Arabic anywhere.

   Placement went through three tries and the measurements decided it:

     drawer, first row  — y=190 instead of 766, but still needs a tap on the
                          hamburger to discover.
     top bar            — visible, but .topbar__center already runs 343px of
                          375 so the delivery line had to truncate, AND the top
                          bar is not sticky: measured at scrollY 800 it sits at
                          top:-800 while the header stays pinned. A switch that
                          disappears as soon as you scroll is not available.
     beside the burger  — the header row is 319px of content in 343px usable.
                          A labelled pill crushed the logo to 0px, and giving
                          the logo a min-width only traded that for the logo
                          overlapping the location icon. Only a bare globe fit,
                          which does not say "Arabic" to someone who cannot read
                          the current language — the whole point of the test.

   So it goes in the search row, which is inside the sticky header, is 343px
   wide, and is the one place with slack: the input is far wider than its
   placeholder needs. The logo keeps its full 86x43 and the delivery line stays
   whole. Cost is a slightly shorter search field.

   Switching goes through the theme's own /localization form rather than a bare
   /ar link, because that form sets Shopify's locale cookie and carries
   return_to for the current page. A plain link forgets the choice on the next
   visit, which would make the test measure a preference nobody could keep. */
(function () {
  var AR = "ar", EN = "en";
  var cur = (window.Shopify && Shopify.locale) || document.documentElement.lang || EN;
  var toAr = cur.toLowerCase().indexOf(AR) !== 0;
  var label = toAr ? "العربية" : "English";
  var target = toAr ? AR : EN;

  function go(e) {
    if (e) e.preventDefault();
    /* The test's own event. Conversion by language can already be read off the
       _ab_locale cart attribute the runtime writes on every arm, so this is not
       here to measure the outcome — it measures the mechanism: did making the
       switch visible actually get used, and from where. Without it a flat
       result is ambiguous between "switching does not help" and "nobody ever
       pressed it". */
    try {
      if (typeof window.okAbEvent === "function") {
        window.okAbEvent("ab_lang_switch", {
          ab_from: cur, ab_to: target,
          ab_placement: "search-row",
          ab_path: location.pathname
        });
      }
    } catch (err) {}
    var f = document.querySelector('form[action*="/localization"]');
    var code = f && f.querySelector('input[name="locale_code"]');
    if (f && code) { code.value = target; f.submit(); return; }
    /* Some templates render no localization form; fall back to the URL prefix
       and keep query and hash so the shopper does not lose their place. */
    var p = location.pathname;
    var dest = toAr ? "/" + AR + p : (p.replace(/^\/ar(?=\/|$)/, "") || "/");
    location.href = dest + location.search + location.hash;
  }

  function mount() {
    var row = document.querySelector(".header__search");
    if (!row || row.querySelector(".oklang")) return;            /* idempotent */

    var a = document.createElement("a");
    a.className = "oklang";
    a.href = "#";
    a.setAttribute("lang", target);
    /* The label is in the destination language, so the element carries that
       language and direction — otherwise a screen reader voices Arabic with an
       English voice, and the glyphs can reorder mid-row. */
    a.setAttribute("dir", toAr ? "rtl" : "ltr");
    a.setAttribute("aria-label", toAr ? "التبديل إلى العربية" : "Switch to English");
    a.innerHTML =
      '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>' +
      '<path d="M3 12h18M12 3c2.5 2.6 2.5 15.4 0 18M12 3c-2.5 2.6-2.5 15.4 0 18" fill="none" ' +
      'stroke="currentColor" stroke-width="2"/></svg><span>' + label + "</span>";
    a.addEventListener("click", go);

    row.appendChild(a);
    row.classList.add("oklang-host");
  }

  /* Scoped to .oklang-host so the row only becomes a flex pair once the pill is
     actually in it — if mount() never runs, the theme's own layout is untouched. */
  var css =
    ".header__search.oklang-host{display:flex!important;align-items:center;gap:10px}" +
    ".header__search.oklang-host>*:not(.oklang){flex:1 1 auto;min-width:0}" +
    ".oklang{flex:0 0 auto;display:inline-flex!important;align-items:center;gap:5px;" +
      "font-weight:700;font-size:13px;line-height:1;white-space:nowrap;" +
      "text-decoration:none;color:#426DB3;background:#EDF1F8;padding:9px 12px;" +
      "border-radius:999px}" +
    ".oklang:hover{background:#E2E9F5;text-decoration:none}" +
    ".oklang svg{flex:0 0 auto}" +
    /* An rtl label inside an ltr row must not drag the row over, so direction is
       scoped to the pill and the box stays laid out by the row. */
    '.oklang[dir="rtl"]{flex-direction:row-reverse}';
  var s = document.createElement("style");
  s.setAttribute("data-oklang", "1");
  s.appendChild(document.createTextNode(css));
  document.head.appendChild(s);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount);
  else mount();
  /* The header is a section group and re-renders on cart and section updates,
     which would drop the pill. */
  document.addEventListener("shopify:section:load", mount);
})();
